import React from 'react';
import Icon from '../AppIcon';

const TrustSignals = ({ className = '' }) => {
  const trustItems = [
    {
      icon: 'Shield',
      label: 'Blockchain Verified',
      description: 'All records stored on immutable blockchain',
      status: 'active'
    },
    {
      icon: 'Lock',
      label: 'End-to-End Encrypted',
      description: 'Your data is encrypted before transmission',
      status: 'active'
    },
    {
      icon: 'Globe',
      label: 'IPFS Distributed',
      description: 'Content stored on decentralized network',
      status: 'active'
    },
    {
      icon: 'Code',
      label: 'Open Source',
      description: 'Transparent and auditable code',
      status: 'active'
    }
  ];

  const contractInfo = {
    address: '0x742d35Cc6634C0532925a3b8D4C9db96590b5b8c',
    network: 'Ethereum Mainnet',
    verified: true
  };

  const formatAddress = (address) => {
    return `${address?.slice(0, 8)}...${address?.slice(-6)}`;
  };

  const handleAddressClick = () => {
    // Open etherscan or similar block explorer
    window.open(`https://etherscan.io/address/${contractInfo?.address}`, '_blank');
  };

  const handleSourceCodeClick = () => {
    // Open GitHub repository
    window.open('https://github.com/polynotary/contracts', '_blank');
  };

  return (
    <div className={`bg-card border border-border rounded-lg p-6 ${className}`}>
      {/* Header */}
      <div className="flex items-center space-x-2 mb-4">
        <Icon name="ShieldCheck" size={20} className="text-success" />
        <h3 className="text-lg font-semibold text-foreground">Trust & Transparency</h3>
      </div>
      {/* Trust Indicators */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        {trustItems?.map((item, index) => (
          <div key={index} className="flex items-start space-x-3 p-3 bg-muted/50 rounded-md">
            <div className="flex-shrink-0 mt-0.5">
              <Icon name={item?.icon} size={16} className="text-success" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center space-x-2">
                <span className="text-sm font-medium text-foreground">{item?.label}</span>
                <div className="w-2 h-2 bg-success rounded-full" />
              </div>
              <p className="text-xs text-muted-foreground mt-1">{item?.description}</p>
            </div>
          </div>
        ))}
      </div>
      {/* Contract Information */}
      <div className="border-t border-border pt-4">
        <h4 className="text-sm font-medium text-foreground mb-3">Smart Contract Details</h4>
        
        <div className="space-y-3">
          {/* Contract Address */}
          <div className="flex items-center justify-between p-3 bg-muted/30 rounded-md">
            <div className="flex items-center space-x-2">
              <Icon name="FileText" size={14} className="text-muted-foreground" />
              <span className="text-xs text-muted-foreground">Contract Address</span>
            </div>
            <button
              onClick={handleAddressClick}
              className="flex items-center space-x-2 text-xs font-mono text-primary hover:text-primary/80 transition-smooth"
            >
              <span>{formatAddress(contractInfo?.address)}</span>
              <Icon name="ExternalLink" size={12} />
            </button>
          </div>

          {/* Network */}
          <div className="flex items-center justify-between p-3 bg-muted/30 rounded-md">
            <div className="flex items-center space-x-2">
              <Icon name="Zap" size={14} className="text-muted-foreground" />
              <span className="text-xs text-muted-foreground">Network</span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="text-xs font-medium text-foreground">{contractInfo?.network}</span>
              {contractInfo?.verified && (
                <Icon name="CheckCircle" size={12} className="text-success" />
              )}
            </div>
          </div>

          {/* Source Code */}
          <div className="flex items-center justify-between p-3 bg-muted/30 rounded-md">
            <div className="flex items-center space-x-2">
              <Icon name="Github" size={14} className="text-muted-foreground" />
              <span className="text-xs text-muted-foreground">Source Code</span>
            </div>
            <button
              onClick={handleSourceCodeClick}
              className="flex items-center space-x-2 text-xs text-primary hover:text-primary/80 transition-smooth"
            >
              <span>View on GitHub</span>
              <Icon name="ExternalLink" size={12} />
            </button>
          </div>
        </div>
      </div>
      {/* Security Notice */}
      <div className="mt-4 p-3 bg-primary/5 border border-primary/20 rounded-md">
        <div className="flex items-start space-x-2">
          <Icon name="Info" size={14} className="text-primary mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-xs text-primary font-medium">Security Notice</p>
            <p className="text-xs text-primary/80 mt-1">
              All notarizations are cryptographically signed and permanently stored on the blockchain. 
              This ensures immutable proof of existence and authenticity.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;